// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__EVwWR","blue":"Tag_blue__w18y9","green":"Tag_green__FZeQx","small":"Tag_small__eM0fP","large":"Tag_large__y9ara"};